import React, { FC } from "react";
import { Redirect, RouteComponentProps } from "react-router-dom";

import { Button, LoadingSpinner, NotFound } from "@xapp/components";

import { UserProfile } from "generated/graphql";
import { ModularLayout } from "layouts";

export interface AuthorizeComponentProps extends RouteComponentProps<any> {
    loadingText?: string;
    profile?: UserProfile;
    redirectUrl?: string;
    error?: Error;
    onLoginRequest(): void;
}

/**
 * AuthorizeComponent is designed to pull the tokens off the URL from a redirect from OAUTH2.0 components.
 */
export const AuthorizeComponent: FC<AuthorizeComponentProps> = ({
    loadingText,
    location,
    onLoginRequest,
    redirectUrl,
    profile,
    error,
}: AuthorizeComponentProps) => {
    const pathname = location.pathname;
    const search = location.search;

    if (error) {
        return (
            <ModularLayout>
                <NotFound message={error.message} />
                <section style={{ display: "flex", justifyContent: "center" }}>
                    <Button variation="primary" label="Back to Login" onClick={onLoginRequest} />
                </section>
            </ModularLayout>
        );
    }

    // login success, we take them to the redirect url
    if (profile) {
        console.log(`Login success for ${profile.email}, redirecting to "${redirectUrl}"`);

        return <Redirect to={redirectUrl || "/"} />;
    }

    if (loadingText) {
        return <LoadingSpinner loadingText={loadingText} />;
    }

    return <Redirect to={{ pathname: "/login", state: { from: { pathname, search } } }} />;
};
